import Phaser from 'phaser';
import dimensions from '../dimensions';
import sounds from '../sounds';

export default class ScoreWindow extends Phaser.Group {
        constructor(game, parent, type) {
                super(game, parent);
                this.type = type;

                this.init();
        }

        init() {
                let background = this.game.add.graphics(0, 0);
                background.beginFill(0x000000, 1);
                background.drawRect(-dimensions.actualWidth / 2, (dimensions.actualHeight - dimensions.gameHeight) / 2 - dimensions.actualHeight / 2, dimensions.actualWidth, dimensions.actualHeight);
                background.alpha = 0.9;
                background.endFill();

                this.add(background);

                this.x = dimensions.gameWidth / 2;
                this.y = dimensions.gameHeight / 2;

                let bg = this.game.add.sprite(0, 25, "sheet", "ui-box");
                bg.anchor.set(0.5);
                this.add(bg);

                this.text = this.game.add.bitmapText(0, -160, "font-title", "Awesome Typing!", 70);
                this.text.anchor.set(0.5);
                this.add(this.text);

                this.star2 = this.game.add.sprite(-150, -20, "sheet", "star");
                this.star2.anchor.set(0.5);
                this.star2.angle = -15;
                this.star2.visible = false;
                this.add(this.star2);

                this.star1 = this.game.add.sprite(0, -30, "sheet", "star");
                this.star1.anchor.set(0.5);
                this.star1.scale.set(1.2);
                this.star1.visible = false;
                this.add(this.star1);

                this.star3 = this.game.add.sprite(150, -10, "sheet", "star");
                this.star3.anchor.set(0.5);
                this.star3.angle = 15;
                this.star3.visible = false;
                this.add(this.star3);

                if (this.type == "Practice") {
                        let accuracy = this.game.add.bitmapText(-180, 140, "font-ui", "Accuracy", 40);
                        accuracy.anchor.set(0.5);
                        this.add(accuracy);

                        let problemkeys = this.game.add.bitmapText(180, 140, "font-ui", "Problem Keys", 40);
                        problemkeys.anchor.set(0.5);
                        this.add(problemkeys);

                        this.accuracy = this.game.add.bitmapText(-180, 180, "font-text", "100%", 30);
                        this.accuracy.anchor.set(0.5);
                        this.add(this.accuracy);

                        this.problemkeys = this.game.add.bitmapText(180, 180, "font-text", "A, S, D", 30);
                        this.problemkeys.anchor.set(0.5);
                        this.add(this.problemkeys);
                } else {
                        let accuracy = this.game.add.bitmapText(-240, 140, "font-ui", "Accuracy", 35);
                        accuracy.anchor.set(0.5);
                        this.add(accuracy);

                        let speed = this.game.add.bitmapText(0, 140, "font-ui", "Speed", 35);
                        speed.anchor.set(0.5);
                        this.add(speed);

                        let problemkeys = this.game.add.bitmapText(240, 140, "font-ui", "Problem Keys", 35);
                        problemkeys.anchor.set(0.5);
                        this.add(problemkeys);

                        this.accuracy = this.game.add.bitmapText(-240, 180, "font-text", "100%", 25);
                        this.accuracy.anchor.set(0.5);
                        this.add(this.accuracy);

                        this.speed = this.game.add.bitmapText(0, 180, "font-text", "30 WPM", 25);
                        this.speed.anchor.set(0.5);
                        this.add(this.speed);

                        this.problemkeys = this.game.add.bitmapText(240, 180, "font-text", "A, S, D", 25);
                        this.problemkeys.anchor.set(0.5);
                        this.add(this.problemkeys);
                }

                let button = this.game.add.sprite(340, 220, "sheet", "mission-button");
                button.anchor.set(0.5);
                button.scale.set(0.4);
                this.add(button);

                button.inputEnabled = true;
                button.events.onInputUp.add(function () {
                        sounds.click.play();
                        this.game.state.start('Menu');
                }.bind(this));

                let text = this.game.add.bitmapText(0, 0, "font-title", "->", 70);
                text.anchor.set(0.5);
                button.addChild(text);

                this.visible = false;
        }

        showPractice(accuracy, keys, hits) {
                this.visible = true;
                this.alpha = 0;

                this.accuracy.text = accuracy + "%";
                this.problemkeys.text = keys;

                let starCount = this.calculatePracticeStars(accuracy, hits);

                this.text.text = GameConfig.scoring.practice[starCount].text;

                let timing = 350;

                this.game.add.tween(this).to({ alpha: 1 }, 350, "Linear", true);

                for (let i = 0; i < this.text.children.length; i++) {
                        this.text.children[i].visible = false;

                        this.game.time.events.add(timing + i * 60, function (i) {
                                this.text.children[i].visible = true;
                        }.bind(this, i));
                }

                this.game.time.events.add(timing + this.text.children.length * 60, function () {
                        for (let i = 1; i <= starCount; i++) {
                                this.game.time.events.add(i * 200, function (i) {
                                        this["star" + i].visible = true;
                                        this.game.add.tween(this["star" + i].scale).from({ x: 0, y: 0 }, 200, "Linear", true);
                                        this.game.add.tween(this["star" + i]).to({ rotation: 6 * Math.PI }, 200, "Linear", true).onComplete.add(function (i) {
                                                var emitter = this.game.add.emitter(this["star" + i].x, this["star" + i].y, 100);
                                                emitter.makeParticles('sheet', ["particle"]);
                                                emitter.maxParticleScale = 1;
                                                emitter.minParticleScale = 0.4;
                                                emitter.setXSpeed(-200, 200);
                                                emitter.setYSpeed(-200, 200);
                                                emitter.setAlpha(1, 0, 500);
                                                emitter.start(true, 500, null, 30);
                                                this.add(emitter);
                                        }.bind(this, i));
                                }.bind(this, i));
                        }
                }.bind(this));
        }

        showMission(accuracy, keys, hits, speed) {
                this.visible = true;
                this.alpha = 0;

                this.accuracy.text = accuracy + "%";
                this.problemkeys.text = keys;

                let starCount = this.calculateMissionStars(accuracy, hits);

                this.speed.text = speed + " WPM";

                this.text.text = GameConfig.scoring.practice[starCount].text;

                let timing = 350;

                this.game.add.tween(this).to({ alpha: 1 }, 350, "Linear", true);

                for (let i = 0; i < this.text.children.length; i++) {
                        this.text.children[i].visible = false;

                        this.game.time.events.add(timing + i * 60, function (i) {
                                this.text.children[i].visible = true;
                        }.bind(this, i));
                }

                this.game.time.events.add(timing + this.text.children.length * 60, function () {
                        for (let i = 1; i <= starCount; i++) {
                                this.game.time.events.add(i * 200, function (i) {
                                        this["star" + i].visible = true;
                                        this.game.add.tween(this["star" + i].scale).from({ x: 0, y: 0 }, 200, "Linear", true);
                                        this.game.add.tween(this["star" + i]).to({ rotation: 6 * Math.PI }, 200, "Linear", true).onComplete.add(function (i) {
                                                var emitter = this.game.add.emitter(this["star" + i].x, this["star" + i].y, 100);
                                                emitter.makeParticles('sheet', ["particle"]);
                                                emitter.maxParticleScale = 1;
                                                emitter.minParticleScale = 0.4;
                                                emitter.setXSpeed(-200, 200);
                                                emitter.setYSpeed(-200, 200);
                                                emitter.setAlpha(1, 0, 500);
                                                emitter.start(true, 500, null, 30);
                                                this.add(emitter);
                                        }.bind(this, i));
                                }.bind(this, i));
                        }
                }.bind(this));
        }

        calculatePracticeStars(accuracy, hits) {
                hits = hits * 100 / GameConfig.letter_count;

                for (let i = 3; i >= 0; i--) {
                        if (GameConfig.scoring.practice[i].accuracy <= accuracy && GameConfig.scoring.practice[i].hits <= hits) return i;
                }
        }

        calculateMissionStars(accuracy, hits) {
                hits = hits * 100 / GameConfig.letter_count;

                for (let i = 3; i >= 0; i--) {
                        if (GameConfig.scoring.practice[i].accuracy <= accuracy) return i;
                }
        }
}


//////////////////
// WEBPACK FOOTER
// ./src/objects/ScoreWindow.js
// module id = 102
// module chunks = 0